import { render, staticRenderFns } from "./AddEditClient.vue?vue&type=template&id=e71b5dd6&"
import script from "./AddEditClient.vue?vue&type=script&lang=js&"
export * from "./AddEditClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports